import RawHtml from 'utils/miscUtils/rawHtml';
import Link from 'components/Globals/Base/Link';
import VodVideo from 'components/VodVideo';
import { NextCustomImage } from 'components/Image';
import useBreakpoint from 'hooks/useBreakpoint';
import type { MediaItem } from 'interfaces/content/Media';
import { FeaturedMedia, Credit } from 'components/Company/AboutCompany/AboutCompanyStyles';
import { parseCaptionWhenAltTextEmpty, parseContentForEmptySpace } from 'utils/parsingUtils/clientSideParsing';
import { Wrapper, LinkWrapper, TextContainer } from './greatPlaceItemStyles';

export interface GreatPlaceToWorkItemProps {
  edition: string;
  text: string;
  link: string;
  video?: string | null;
  image: MediaItem | null;
  setEnableSlide: (value: boolean) => void;
}

const GreatPlaceToWorkItem = ({ edition, text, link, video, image, setEnableSlide }: GreatPlaceToWorkItemProps) => {
  let greatPlaceFeaturedItem;
  const isMobile = useBreakpoint('mdMax');
  const isTablet = useBreakpoint('hybridMax');

  if (video) {
    greatPlaceFeaturedItem = (
      <FeaturedMedia>
        <VodVideo videoId={video} />
      </FeaturedMedia>
    );
  } else if (image) {
    greatPlaceFeaturedItem = (
      <FeaturedMedia className='about-featured'>
        <NextCustomImage
          src={image?.src || ''}
          alt={parseCaptionWhenAltTextEmpty(image)}
          width='975'
          height='650'
        />
        {image.credit && <Credit>{image.credit}</Credit>}
      </FeaturedMedia>
    );
  } else {
    greatPlaceFeaturedItem = null;
  }

  return (
    <Wrapper>
      <TextContainer
        onMouseEnter={() => {
          if (!isMobile && !isTablet) setEnableSlide(false);
        }}
        onMouseLeave={() => {
          if (!isMobile && !isTablet) setEnableSlide(true);
        }}
      >
        <span className='bolded'> {edition || ''}</span>
        <br />
        {RawHtml({ html: parseContentForEmptySpace(text) })}
        <LinkWrapper>
          <Link
            href={link}
            type='primaryButton'
            className='great-places-link'
          >
            Read the Great Place To Work Review
          </Link>
        </LinkWrapper>
      </TextContainer>
      {greatPlaceFeaturedItem}
    </Wrapper>
  );
};

export default GreatPlaceToWorkItem;
